/// <reference types="vite/client" />
import { createClient } from '@supabase/supabase-js';

// Safe access to env variables for both Vite and Node environments
const env = import.meta.env || {};
const supabaseUrl = env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl || !supabaseAnonKey) {
    console.warn('⚠️ Supabase credentials not found. Running in offline mode.');
}

export const supabase = createClient(
    supabaseUrl || 'https://placeholder.supabase.co',
    supabaseAnonKey || 'placeholder-key',
    {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
        }
    }
);

// Helper to check if Supabase is configured
export const isSupabaseConfigured = () => {
    return !!(supabaseUrl && supabaseAnonKey && !supabaseUrl.includes('placeholder'));
};

// Types for our app
export interface UserProfile {
    id: string;
    username: string;
    avatar: string;
    created_at: string;
}

export interface UserProgress {
    user_id: string;
    xp: number;
    completed_modules: string[];
    badges: string[];
    updated_at: string;
}
